import { Box } from '@mui/system'
import React from 'react'
import { useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import { getFilterUsersBatchActionsStatusList, getUsersBatchActionsStatusList } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import { selectUsersBatchActionsStatus } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import SortByList from '../../../components/PageHelpers/Sort'
import IconBtnV2 from '../../../components/Buttons/IconBtnV2'
import UseTranslation from '../../../hooks/UseTranslation'
import OfoqMultiAutoComplete from '../../../components/Forms/OfoqMultiAutoComplete'
import FilterByForm from '../../../components/PageHelpers/FilterByForm'
import ActiveFiltersWithKey from '../../../components/PageHelpers/ActiveFiltersWithKey'
import FilterAltOutlinedIcon from '../../../images/filter.svg'
import CookiesStorageService from '../../../services/CookiesStorageService'

const Desktop = ({
  openModal, setOpenModal, status, setStatus, types, setTypes,
}) => {
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const { t } = UseTranslation()
  const isFilteredArraysNotEmpty = Object.values(usersBatchActionsStatusStore?.activeFilters).some(
    (singleFilter) => singleFilter?.length,
  )
  const isSamlUser = CookiesStorageService.getIsSamlUser()

  return (
    <Box>

      <Box sx={styles.sortAndFilters}>
        <SortByList
          actionToDispatch={getUsersBatchActionsStatusList}
          store={usersBatchActionsStatusStore}
          sendQueryAsObject
        />

          <IconBtnV2
            icon={openModal ? <CloseIcon /> : <img src={FilterAltOutlinedIcon} alt="filter icon" />}
            onClick={() => setOpenModal(!openModal)}
            customStyle={styles.filterButton}
          />
      </Box>

      <FilterByForm formStatus={openModal} customStyles={styles.filterForm}>
        {!isSamlUser && (
        <OfoqMultiAutoComplete
          name={t?.Type}
          store={usersBatchActionsStatusStore?.filterList?.types}
          defaultOption={types}
          refState={setTypes}
        />
        )}
        <OfoqMultiAutoComplete
          name={t?.Status}
          store={usersBatchActionsStatusStore?.filterList?.status}
          defaultOption={status}
          refState={setStatus}
        />
      </FilterByForm>
      {isFilteredArraysNotEmpty && (
      <ActiveFiltersWithKey
        store={usersBatchActionsStatusStore}
        actionToDispatch={getFilterUsersBatchActionsStatusList}
        customStyles={styles.activeFilter}
      />
      )}
    </Box>
  )
}

const styles = {
  sortAndFilters: { display: { xs: 'none', sm: 'flex' }, justifyContent: 'end', my: '10px' },
  filterButton: {
    height: '40px',
    width: '40px',
    borderRadius: '12px',
    border: '1px solid #e2e8ee',
    backgroundColor: 'white',
    color: 'text.hint',
    overflow: 'hidden',
  },
  filterForm: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '96%',
    padding: {
      xs: '20px 20px 0px', sm: '20px 36px 0px', md: '20px 20px 0px', lg: '20px 22px 0px',
    },
    alignItems: 'flex-start',
    marginTop: { xs: '0px', sm: '10px !important' },
    gap: '20px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
}

export default Desktop
